module.exports = __webpack_public_path__ + "images/district_back.1787648603550.png";